/**
 * Flow B · explore routes — WP-C.
 *
 * B5 `/explore` · B6 `/explore/:domain` · B7 `/explore/:domain/:category`
 *
 * `:domain` is the two-digit life-domain code from `Oprappo Architecture.dc.html § 04`,
 * and `:category` is a slug — the shape the manifest already uses for H3
 * (`/explore/2/grocery`). B6 and B7 are drawn against domain 9 / এসি ও ফ্রিজ, so the
 * harness fixtures are `B6: { "domain": "9" }` and
 * `B7: { "domain": "9", "category": "ac-fridge" }`. `tools/` is outside this package's
 * grant, so those values are reported rather than written.
 *
 * App.tsx mounts this array; it is not edited from here.
 */
import type { RouteObject } from 'react-router-dom';
import { withSurfaceStates } from '../../states/boundary.js';
import { CategoryScreen, DomainScreen, ExploreScreen } from './explore.js';

/**
 * WP-K · state branches. `withSurfaceStates` wraps every element of this group in the
 * boundary for its matrix column (discovery · আবিষ্কার); see
 * `apps/web/src/states/boundary.tsx`. It changes nothing about the healthy render — no
 * state resolves unless an API error body says so, so the screens below are untouched
 * and their fidelity gate still measures what it measured.
 */
export const exploreRoutes: RouteObject[] = withSurfaceStates('discovery', [
  { path: '/explore', element: <ExploreScreen /> },
  { path: '/explore/:domain', element: <DomainScreen /> },
  { path: '/explore/:domain/:category', element: <CategoryScreen /> },
]);
